import sha256 from 'crypto-js/sha256';
import md5 from 'crypto-js/md5';

export class CryptoHelper {
        createSHA256FromString(string){
            return sha256(string).toString();
        }
        createMD5FromString(string){
            return md5(string).toString();
        }
}